import { StatusType, status } from "../../typeStatus"

export const PURCHASE = 'PURCHASE'
export const PURCHASE_SUCCESS = 'PURCHASE_SUCCESS'
export const PURCHASE_ERROR = 'PURCHASE_ERROR'
export const PURCHASE_RESET = 'PURCHASE_RESET'

export enum OrderOrigin {
  Cart = 'Cart',
  JobPostingForm = 'JobPostingForm',
}

export interface Metadata {
  paylink: string
  preferenceId: string
  purchaseId: string
}

export interface TransactionData {
  countryCode: string
  gatewayType: string
  id: number
  metadata: Metadata
  orderId: number
  vendorId: number
  totalAmount: number
}
export interface PurchaseState {
  transactionInfo: TransactionData | null
  transactionStatus: StatusType
  origin?: OrderOrigin
}

export const InitialState: PurchaseState = {
  transactionInfo: null,
  transactionStatus: status.initial,
}

export interface Purchase {
  type: typeof PURCHASE
  payload: { origin?: OrderOrigin }
}

export interface PurchaseSuccess {
  type: typeof PURCHASE_SUCCESS
  payload: TransactionData
}

export interface PurchaseError {
  type: typeof PURCHASE_ERROR
  payload: boolean
}

export interface PurchaseReset {
  type: typeof PURCHASE_RESET
  payload: null
}

export type PurchaseActions = Purchase | PurchaseSuccess | PurchaseError | PurchaseReset
